export default __webpack_public_path__ + "static/media/1.33b192bf.jpg";